module.exports = __webpack_public_path__ + "static/media/slider2.72370916.jpg";